import React, { useContext, useState } from 'react';
// import { useNavigate  } from 'react-router';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DayJsUtils from '@date-io/dayjs';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import { BASE_URL, SCHEDULE_SERVICE_FOR_IFRAME } from '../../utility/urls';
import { ScheduleData, RESET_BOOKING } from './context';
import { View } from './view';
import axios from 'axios';



export const Appointment = () => {
    NProgress.start();
    const { state, dispatch } = useContext(ScheduleData);
    const { control, handleSubmit, reset } = useForm();
    const [alert, setAlert] = useState(false);
    const [payNow, setPayNow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const inputFields = {
        year: {
            name: 'Year',
        },
        make: {
            name: 'Make',
        },
        model: {
            name: 'Model',
        },
        vin: {
            name: 'VIN',
        },
    };

    const inputFieldsForCustomerData = {
        first: {
            name: 'First Name',
        },
        last: {
            name: 'Last Name',
        },
        email: {
            name: 'Email Address',
        },
        phone: {
            name: 'Mobile Phone',
        },
    };

    const payNowSuccessfully = async (email) => {
        try {
            const checkoutUrl = BASE_URL.replace(/\/+$/, '') + '/checkout';
            const clientSecret = await axios.post(checkoutUrl, {
                item: state.rentalStatus === 'true' ? 'rental' : 'norental',
                email,
            });

            if (clientSecret.data?.error || !clientSecret.data?.id) {
                setAlert({ type: 'error', message: 'Unable to start payment.' });
                return false;
            }

            setPayNow(clientSecret.data.id);
            return true;
        } catch (error) {
            const message = error.response
                ? `Unable to start payment (HTTP ${error.response.status}).`
                : 'Unable to start payment. Check your connection and try again.';
            setAlert({ type: 'error', message });
            return false;
        }
    }

    const payNowCloseHandler = () => {
        setPayNow(false);
    };

    const submitFormHandler = async (allData, paymentIntentId) => {

        const { make, year, model, first, last, email, phone, vin } = allData;

        if (
            !year ||
            !make ||
            !model ||
            !first ||
            !last ||
            !email ||
            !phone ||
            !state.address.city ||
            !state.address.state ||
            !state.address.zip
        ) {
            setAlert({ type: 'error', message: 'All fields are required!' });
            return false;
        }

        if (!state.agreement) {
            setAlert({ type: 'error', message: 'You should accept our agreement' });
            return false;
        }
        setAlert(false);
        setIsLoading(true);

        const data = {
            email,
            first_name: first,
            last_name: last,
            phone,
            rental: state.rentalStatus === 'true' || false,
            make,
            model,
            year,
            vin,
            pickup_address: state.address,
            pickup_date: dayjs(state.pickup_date).format('MM-DD-YYYY'),
            pickup_time: state.pickup_time,
        };

        
        if (!paymentIntentId) {
            await payNowSuccessfully(email);
            setIsLoading(false);
            return;
        }

        try {
            const result = await axios.post(BASE_URL + SCHEDULE_SERVICE_FOR_IFRAME, {
                ...data,
                payment_intent_id: paymentIntentId,
            });

            if (result.status >= 200 && result.status < 300) {
                setAlert({
                    type: 'success',
                    message: 'Your appointment was successfully created!',
                });
                reset();
                dispatch({ type: RESET_BOOKING });
                return true;
            }
        } catch (error) {
            setAlert({
                type: 'error',
                message: error.response?.data?.message || 'Unable to create appointment.',
            });
        } finally {
            setIsLoading(false);
        }
        return false;
    };

    return (
        <MuiPickersUtilsProvider utils={DayJsUtils}>
            <View
                inputFields={inputFields}
                inputFieldsForCustomerData={inputFieldsForCustomerData}
                alert={alert}
                control={control}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                submitFormHandler={submitFormHandler}
                payNow={payNow}
                payNowCloseHandler={payNowCloseHandler}
            />

        </MuiPickersUtilsProvider>
    );
};
